<template>
  <!-- ******************* -->
  <!-- *      Modal      * -->
  <!-- ******************* -->
  <!-- This modal is for editing or creating new surveys -->
  <div
    class="modal fade"
    id="editSurveyDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editSurveyForm">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal Title -->
            <h4 class="modal-title">
              <b>{{ dialogTitle }}</b>
            </h4>
            <!-- History Icon  -->
            <div v-if="surveyData.SurveyId">
              <label class="control-label">ID: {{ surveyData.SurveyId }}</label>
              <i
                id="showSurveyHistoryInfoIcon"
                class="material-icons md-24"
                @click="showSurveyHistory()"
                >history</i
              >
              <b-tooltip
                ref="tooltip"
                target="showSurveyHistoryInfoIcon"
                :delay="globals.tooltipDelay"
                >{{ lang.U1087 }}</b-tooltip
              >
            </div>
          </div>
          <div class="modal-body">
            <div
              class="panel-group"
              id="accordionEditSurvey"
              role="tablist"
              aria-multiselectable="true"
            >
              <div class="panel panel-default">
                <!-- Accordion entry 1 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditSurveyGeneral"
                  data-toggle="collapse"
                  data-parent="#accordionEditSurvey"
                  href="#collapseEditSurveyGeneral"
                  aria-expanded="true"
                  aria-controls="collapseEditSurveyGeneral"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.U0015 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditSurveyGeneral"
                  class="panel-collapse collapse in"
                  role="tabpanel"
                  aria-labelledby="headingEditSurveyGeneral"
                >
                  <div class="panel-body">
                    <!-- Add inputs here -->
                    <div
                      class="form-group"
                      v-if="
                        !feature.isAudiTarget ||
                        !feature.isEnabled('audi_importers')
                      "
                    >
                      <label
                        for="editSurveyClientSelect"
                        class="col-md-2 control-label"
                        >{{ lang.U0016 }}*</label
                      >
                      <div class="col-md-10">
                        <select2
                          class="form-control"
                          id="editSurveyClientSelect"
                          ref="editSurveyClientSelect"
                          name="editSurveyClientSelect"
                          v-model="surveyData.ClientGuid"
                          :key="surveyData.ClientGuid"
                          :afterChange="getSurveyGroupList"
                          :placeholder="lang.U1000"
                          :allowClear="dialogModeAdd"
                          :disabled="!dialogModeAdd && !copySurvey"
                          required
                        >
                          <option
                            v-for="client in clientList"
                            :key="'option_' + client.ClientGuid"
                            :value="client.ClientGuid"
                          >
                            {{ client.ClientName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group" v-else>
                      <label
                        for="editSurveyImporterSelect"
                        class="col-md-2 control-label"
                        >{{ lang.U1075 }}</label
                      >
                      <div class="col-md-10">
                        <select2
                          class="form-control"
                          id="editSurveyImporterSelect"
                          ref="editSurveyImporterSelect"
                          :afterChange="getSurveyGroupList"
                          :placeholder="lang.U1000"
                          :allowClear="true"
                          v-model="surveyData.ImporterGuid"
                        >
                          <option
                            v-for="importer in importerList"
                            :key="importer.ImporterGuid"
                            :value="importer.ImporterGuid"
                          >
                            {{ importer.ImporterName }}
                          </option>
                        </select2>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputTitle" class="col-md-2 control-label"
                        >{{ lang.U0017 }}*</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputTitle"
                          name="inputTitle"
                          v-model="surveyData.SurveyTitle"
                          @keyup="validateInput('inputTitle')"
                          required
                        />
                        <span
                          v-show="inputHasError('inputTitle')"
                          class="help-block error text-danger"
                          >{{ lang.U0020 }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputTitle2" class="col-md-2 control-label">{{
                        lang.U0018
                      }}</label>
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputTitle2"
                          v-model="surveyData.SurveyTitle2"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="inputTitle3" class="col-md-2 control-label">{{
                        lang.U0019
                      }}</label>
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputTitle3"
                          v-model="surveyData.SurveyTitle3"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="selectSurveySkillLevel"
                        class="col-md-2 control-label"
                        >{{ lang.U0040 }}</label
                      >
                      <div class="col-md-10">
                        <select
                          class="form-control"
                          id="selectSurveySkillLevel"
                          v-model.number="surveyData.SurveySkillLevel"
                        >
                          <option v-for="i in 5" :key="i">{{ i }}</option>
                        </select>
                      </div>
                      <b-tooltip
                        target="selectSurveySkillLevel"
                        :delay="globals.tooltipDelay"
                        placement="right"
                        boundary="viewport"
                      >
                        1 &rarr; {{ lang.U0041 }}
                        <br />
                        <br />...
                        <br />
                        <br />
                        5 &rarr; {{ lang.U0042 }}
                      </b-tooltip>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputSurveyActive"
                        class="col-md-2 control-label"
                        >{{ lang.U1037 }}</label
                      >
                      <div class="col-md-10">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputSurveyActive"
                              v-model="surveyData.SurveyActive"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputCXSurvey"
                        class="col-md-2 control-label"
                        >{{ lang.U1038 }}</label
                      >
                      <div class="col-md-10">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              class="form-control"
                              type="checkbox"
                              id="inputCXSurvey"
                              v-model="surveyData.CXSurvey"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-if="surveyData.CXSurvey">
                      <label
                        for="inputCXSurveyExploration"
                        class="col-md-2 control-label"
                        >{{ lang.U1088 }}</label
                      >
                      <div class="col-md-10">
                        <div class="checkbox" style="float: left">
                          <label>
                            <input
                              type="checkbox"
                              id="inputCXSurveyExploration"
                              v-model="surveyData.CXExploration"
                            />
                            <span class="checkbox-material">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label
                        for="inputSurveyShowHistoryCounter"
                        class="col-md-2 control-label"
                        >{{ lang.U1092 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="number"
                          min="0"
                          id="inputSurveyShowHistoryCounter"
                          v-model.number="surveyData.SurveyShowHistoryCounter"
                        />
                      </div>
                      <b-tooltip
                        target="inputSurveyShowHistoryCounter"
                        :delay="globals.tooltipDelay"
                        >0 = disabled</b-tooltip
                      >
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 2 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditSurveyVisibility"
                  data-toggle="collapse"
                  data-parent="#accordionEditSurvey"
                  href="#collapseEditSurveyVisibility"
                  aria-expanded="false"
                  aria-controls="collapseEditSurveyVisibility"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.U1001 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditSurveyVisibility"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditSurveyVisibility"
                >
                  <div class="panel-body" style="padding: 15px">
                    <div class="tab-content col-xs-12">
                      <div
                        class="tab-pane tab-content-visibility active in"
                        id="visibilitySettingsTabContent"
                      >
                        <p
                          style="
                            font-size: 16px;
                            color: black;
                            padding-top: 15px;
                          "
                        >
                          {{ currentVisibilitySettings.headerText }}
                        </p>
                      </div>

                      <div class="col-xs-12" style="padding: 0px">
                        <a
                          role="button"
                          class="btn btn-default"
                          style="margin: 0 0 2px 0"
                          @click="toggleAllVisibilityGroups()"
                        >
                          <i
                            class="material-icons md-24 text-primary"
                            v-if="
                              currentVisibilitySettings.selectedGroups.length ==
                              Object.keys(surveyGroupList).length
                            "
                            >check_box</i
                          >
                          <i
                            class="material-icons md-24"
                            v-else-if="
                              currentVisibilitySettings.selectedGroups.length ==
                              0
                            "
                            >check_box_outline_blank</i
                          >
                          <i class="material-icons md-24 text-primary" v-else
                            >indeterminate_check_box</i
                          >
                          <span
                            v-if="
                              currentVisibilitySettings.selectedGroups.length !=
                              Object.keys(surveyGroupList).length
                            "
                            >{{ lang.U1032 }}</span
                          >
                          <span v-else>{{ lang.U1033 }}</span>
                        </a>
                      </div>

                      <div class="table-content-visibility">
                        <table class="table table-hover" style="margin: 0px">
                          <tbody>
                            <tr
                              v-for="(group, key) in surveyGroupList"
                              :key="key"
                            >
                              <td style="padding: 4px; width: 20%">
                                <div class="checkbox" style="margin: 0px">
                                  <label>
                                    <input
                                      type="checkbox"
                                      :value="key"
                                      :id="'cb_visibilitygroups_' + key"
                                      v-model="
                                        currentVisibilitySettings.selectedGroups
                                      "
                                    />
                                    <span class="checkbox-material">
                                      <span class="check"></span>
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td
                                style="
                                  font-size: 16px;
                                  padding: 6px;
                                  width: 80%;
                                "
                              >
                                <label
                                  role="button"
                                  :for="'cb_visibilitygroups_' + key"
                                  class="text-black nopadding"
                                  style="width: 100%"
                                  >{{ group }}</label
                                >
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 3 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditSurveyLocalization"
                  data-toggle="collapse"
                  data-parent="#accordionEditSurvey"
                  href="#collapseEditSurveyLocalization"
                  aria-expanded="false"
                  aria-controls="collapseEditSurveyLocalization"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyTranslationLocales_Read'
                    )
                  "
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.U1017 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditSurveyLocalization"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditSurveyLocalization"
                  v-if="
                    globals.isAccessAllowed(
                      'LoopOp_SurveyTranslationLocales_Read'
                    )
                  "
                >
                  <div class="panel-body">
                    <div>
                      <div class="form-group col-md-12">
                        <label
                          for="inputNewLanguage"
                          class="col-md-2 control-label"
                          >{{ lang.U1018 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            class="form-control"
                            id="inputNewLanguage"
                            :key="surveyData.ClientGuid"
                            v-model="newSurveyLanguage"
                            :afterChange="getLocales"
                            :placeholder="lang.U1067"
                            :allowClear="true"
                          >
                            <option
                              v-for="(language, key) in languageList"
                              :key="key"
                              :value="key"
                            >
                              {{ language }}
                            </option>
                          </select2>
                        </div>
                      </div>
                      <div class="form-group col-md-12">
                        <label
                          for="inputNewLanguageLocale"
                          class="col-md-2 control-label"
                          >{{ lang.U1059 }}</label
                        >
                        <div class="col-md-7">
                          <select2
                            class="form-control"
                            id="inputNewLanguageLocale"
                            v-model="newSurveyLanguageLocale"
                            :key="newSurveyLanguage"
                            :placeholder="lang.U1068"
                            :allowClear="true"
                            :disabled="
                              !newSurveyLanguage ||
                              languageLocaleList.length < 1
                            "
                          >
                            <option
                              v-for="locale in languageLocaleList"
                              :key="locale.LocaleCode"
                              :value="locale.CountryCode"
                            >
                              {{ locale.CountryName }}
                            </option>
                          </select2>
                        </div>
                        <button
                          id="addNewSurveyLanguage"
                          type="button"
                          class="btn btn-raised dialog-btn-primary"
                          style="margin-top: 0px"
                          :disabled="!newSurveyLanguageLocale"
                          @click="addNewSurveyLanguage()"
                        >
                          {{ lang.U1019 }}
                        </button>
                      </div>
                    </div>

                    <!-- This table displays the custom properties a client -->
                    <table
                      class="table table-striped table-hover"
                      style="margin: 0px"
                    >
                      <thead>
                        <tr>
                          <!-- Add table header here -->
                          <th style="width: 60%" class="text-center">
                            {{ lang.U1020 }}
                          </th>
                          <th style="width: 20%" class="text-center">
                            {{ lang.U1069 }}
                          </th>
                          <th style="width: 20%" class="text-center">
                            {{ lang.U1021 }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            lang, key
                          ) in surveyData.SurveySelectedLanguages"
                          :key="key"
                        >
                          <td>
                            {{
                              getLocaleString(
                                lang.LanguageCode,
                                lang.CountryCode
                              )
                            }}
                          </td>
                          <td style="padding: 0px">
                            <div class="radio" style="margin: 0px">
                              <label style="margin-top: 9px">
                                <input
                                  type="radio"
                                  name="rd_defaultRepLanguage"
                                  :value="key"
                                  :id="'rd_defaultRepLanguage_' + key"
                                  :checked="lang.IsDefault"
                                  @change="setDefaultSurveyLanguage(key)"
                                />
                                <span class="circle"></span>
                                <span class="check"></span>
                              </label>
                            </div>
                          </td>
                          <td class="nopadding">
                            <div style="float: none">
                              <!-- <button type="button" class="btn" style="padding: 0px; margin: 7px;" :disabled="true" @click="redirectToSurveyTranslation(getLocaleString(lang.LanguageCode, lang.CountryCode))"><i class="material-icons md-24">edit</i></button> -->
                              <button
                                type="button"
                                class="btn"
                                style="padding: 0px; margin: 7px"
                                @click="
                                  removeSelectedLanguage(
                                    lang.LanguageCode,
                                    lang.CountryCode
                                  )
                                "
                              >
                                <i
                                  class="material-icons md-24"
                                  style="color: red"
                                  >clear</i
                                >
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- Accordion entry 4 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditSurveyAttachment"
                  data-toggle="collapse"
                  data-parent="#accordionEditSurvey"
                  href="#collapseEditSurveyAttachment"
                  aria-expanded="false"
                  aria-controls="collapseEditSurveyAttachment"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.U1022 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditSurveyAttachment"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditSurveyAttachment"
                >
                  <div class="panel-body">
                    <!-- Add inputs here -->
                    <div class="form-group">
                      <label
                        for="inputAttachmentName"
                        class="col-md-2 control-label"
                        >{{ lang.U1023 }}</label
                      >
                      <div class="col-md-10">
                        <input
                          type="text"
                          class="form-control"
                          id="inputAttachmentName"
                          v-model="
                            surveyData.SurveyAttachments[0].DownloadDescription
                          "
                        />
                      </div>
                    </div>

                    <div class="form-group form-group-files">
                      <label
                        for="inputSurveyAttachmentFile"
                        class="col-md-2 control-label"
                        >{{ lang.U1024 }}</label
                      >
                      <div class="col-md-8">
                        <input
                          id="inputSurveyAttachmentFile"
                          class="form-control"
                          type="file"
                          style="cursor: pointer"
                          :title="lang.U1034"
                          @change="onSurveyAttachmentFileChange"
                        />
                        <div class="input-group">
                          <label
                            v-if="
                              !surveyData.SurveyAttachments[0].DownloadFileName
                            "
                            style="padding-top: 12px"
                            >{{ lang.U1025 }}</label
                          >
                          <label v-else style="padding-top: 12px">{{
                            surveyData.SurveyAttachments[0].DownloadFileName
                          }}</label>
                          <span class="input-group-btn input-group-sm">
                            <button
                              type="button"
                              class="btn btn-fab btn-fab-mini"
                            >
                              <i class="material-icons">attach_file</i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <span class="input-group-btn input-group-sm">
                          <button
                            type="button"
                            class="btn btn-fab btn-fab-mini"
                            @click="
                              globals.downloadFile(
                                surveyData.SurveyAttachments[0].DownloadId
                              )
                            "
                            :title="lang.U1035"
                            :disabled="
                              !surveyData.SurveyAttachments[0].DownloadId
                            "
                          >
                            <i class="material-icons">file_download</i>
                          </button>
                        </span>
                        <span class="input-group-btn input-group-sm">
                          <button
                            type="button"
                            class="btn btn-fab btn-fab-mini"
                            @click="removeSurveyAttachmentFile()"
                            :title="lang.U1036"
                            :disabled="
                              !surveyData.SurveyAttachments[0].DownloadId
                            "
                          >
                            <i class="material-icons">clear</i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Accordion entry 5 -->
                <div
                  class="panel-heading"
                  role="button"
                  id="headingEditSurveyOthers"
                  data-toggle="collapse"
                  data-parent="#accordionEditSurvey"
                  href="#collapseEditSurveyOthers"
                  aria-expanded="false"
                  aria-controls="collapseEditSurveyOthers"
                >
                  <h4 class="panel-title">
                    <a class="collapsed">{{ lang.U1026 }}</a>
                  </h4>
                </div>
                <div
                  id="collapseEditSurveyOthers"
                  class="panel-collapse collapse"
                  role="tabpanel"
                  aria-labelledby="headingEditSurveyOthers"
                >
                  <div class="panel-body">
                    <!-- Add inputs here -->
                    <div class="form-group form-group-files">
                      <label
                        for="inputSurveyLogoFile"
                        class="col-md-2 control-label"
                        >{{ lang.U1027 }}</label
                      >
                      <div class="col-md-8">
                        <input
                          id="inputSurveyLogoFile"
                          class="form-control"
                          type="file"
                          accept=".jpg, .jpeg, .png, .bmp"
                          style="cursor: pointer"
                          :title="lang.U1034"
                          @change="onSurveyLogoFileChange"
                        />
                        <div class="input-group">
                          <label
                            v-if="!surveyData.SurveyLogoFileName"
                            style="padding-top: 12px"
                            >{{ lang.U1028 }}</label
                          >
                          <label v-else style="padding-top: 12px">{{
                            surveyData.SurveyLogoFileName
                          }}</label>
                          <span class="input-group-btn input-group-sm">
                            <button
                              type="button"
                              class="btn btn-fab btn-fab-mini"
                            >
                              <i class="material-icons">attach_file</i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <span class="input-group-btn input-group-sm">
                          <button
                            type="button"
                            class="btn btn-fab btn-fab-mini"
                            id="showSurveyLogoButton"
                            @click="
                              globals.downloadFile(surveyData.SurveyLogoId)
                            "
                            :title="lang.U1035"
                            :disabled="!surveyData.SurveyLogoId"
                          >
                            <i class="material-icons">file_download</i>
                          </button>
                        </span>
                        <span class="input-group-btn input-group-sm">
                          <button
                            type="button"
                            class="btn btn-fab btn-fab-mini"
                            @click="removeSurveyLogoFile()"
                            :title="lang.U1036"
                            :disabled="!surveyData.SurveyLogoId"
                          >
                            <i class="material-icons">clear</i>
                          </button>
                        </span>
                      </div>
                      <b-tooltip
                        ref="tooltip"
                        target="inputSurveyLogoFile"
                        :delay="globals.tooltipDelay"
                        placement="left"
                        v-if="surveyData.SurveyLogoId"
                      >
                        <img
                          :src="'/api/Download/' + surveyData.SurveyLogoId"
                          height="200"
                        />
                      </b-tooltip>
                    </div>

                    <div class="form-group">
                      <label
                        for="inputMinimumAttachments"
                        class="col-md-2 control-label"
                        >{{ lang.U1029 }}</label
                      >
                      <div class="col-md-7">
                        <input
                          type="number"
                          class="form-control"
                          id="inputMinimumAttachments"
                          min="0"
                          max="100"
                          step="1"
                          v-model="surveyData.SurveyMinimumAttachments"
                        />
                      </div>

                      <div class="checkbox col-md-3">
                        <label class="pull-left">
                          <input
                            type="checkbox"
                            v-model="surveyData.SurveyShowAttachmentsPage"
                          />
                          <span class="checkbox-material">
                            <span class="check"></span>
                          </span>
                          {{ lang.U1074 }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <b-alert
              variant="danger"
              dismissible
              :show="showAlert"
              @dismissed="showAlert = false"
              >{{ lang.U0021 }}</b-alert
            >
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.U0022 }}
            </button>
            <button
              id="survey-management-edit-modal-save-button"
              type="button"
              class="btn btn-raised dialog-btn-primary"
              @click="validateBeforeSubmit('editSurveyDialog')"
              :disabled="
                !globals.isAccessAllowed('LoopOp_Surveys_Update') &&
                !dialogModeAdd
              "
            >
              {{ lang.U0023 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";
import UseProjectWave from "../../services/ProjectWaves";
import VueTreeSelect from "@riophae/vue-treeselect";

export default {
  name: "SurveyManagementEditModal",
  components: { Select2, treeselect: VueTreeSelect },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editSurveyDialog").on("hidden.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });
  },
  methods: {
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      let result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        let idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    /**
     * Explicit validation for the vue-treeselect compontent, because it is not able to give them an id.
     * @returns {boolean} true if valid, or wave selector is disabled.
     */
    validateWaveSelector() {
      let result = false;
      // no validation needed if wave selector disabled
      if (!this.surveyData.isMasterSurvey) return true;
      const guidRegex = new RegExp(
        /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i
      );
      if (
        this.surveyData.MasterSurveyForWave &&
        this.surveyData.MasterSurveyForWave.trim().length > 0 &&
        guidRegex.test(this.surveyData.MasterSurveyForWave.toLowerCase())
      )
        result = true;
      if (result) {
        $(".inputMasterSurveyForWave").parent().removeClass("has-error"); // has-error has to be added to the form-group element
      } else {
        $(".inputMasterSurveyForWave").parent().addClass("has-error");
      }
      return result;
    },

    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      if (this.invalidInputIds.indexOf(id) > -1) return true;
      return false;
    },

    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialogId) {
      var result = true;

      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }

      result = this.validateWaveSelector() && result;

      if (dialogId == "editSurveyDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditSurveyDialogData();
      }
    },

    // Resets all validation errors for the given dialog
    resetValidationErrors(dialogId) {
      var elements = $("#" + dialogId).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },

    showSurveyHistory() {
      let config = {
        type: "Survey",
        guid: this.selectedSurvey.SurveyGuid,
        id: this.selectedSurvey.SurveyId,
      };
      this.globals.$emit("showElementHistory", config);
    },

    // Redirects to the survey translation tool
    redirectToSurveyTranslation(key) {
      // TODO:
      console.debug("open survey translation for: " + key);
    },

    // Returns true, if the given language is already selected, otherwise false
    isLanguageSelected(languageCode, countryCode) {
      var langList = this.surveyData.SurveySelectedLanguages;
      if (!langList || !languageCode) return false;

      for (var i = 0; i < langList.length; i++) {
        if (langList[i].LanguageCode == languageCode) {
          if (
            (!langList[i].CountryCode || langList[i].CountryCode.length < 1) &&
            !countryCode.length
          )
            return true;
          else if (langList[i].CountryCode == countryCode) return true;
        }
      }
      return false;
    },

    getLocaleString(languageCode, countryCode) {
      if (!this.languageList || !this.localesList) return "";

      var result = this.languageList[languageCode];

      var ll = this.localesList.filter((l) => {
        return l.LanguageCode == languageCode;
      });

      if (ll && ll.length > 0 && ll[0].Locales) {
        var loc = ll[0].Locales.filter((c) => {
          return c.CountryCode == countryCode;
        });
        if (loc && loc.length > 0) result += " - " + loc[0].CountryName;
      }
      return result;
    },

    getLocales() {
      let loc = this.localesList.filter((l) => {
        return l.LanguageCode == this.newSurveyLanguage;
      });
      if (loc && loc.length > 0 && loc[0].Locales)
        this.languageLocaleList = loc[0].Locales;
      else this.languageLocaleList = [];
    },

    getSurveyGroupList() {
      if (!this.surveyData.ClientGuid) return;
      let query = `api/SecurityGroups/Data/Client/${this.surveyData.ClientGuid}`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.surveyGroupList = data;
        },
        error: () => {
          console.error(
            "Survey group data access failed in getSurveyGroupList()"
          );
          this.globals.showErrorSnackbar(this.lang.U1085);
        },
      });
    },

    // Adds a new survey language to the surveydata
    addNewSurveyLanguage() {
      if (!this.newSurveyLanguage) return;
      if (
        this.isLanguageSelected(
          this.newSurveyLanguage,
          this.newSurveyLanguageLocale
        )
      ) {
        this.globals.showErrorSnackbar(this.lang.U1040);
        this.newSurveyLanguageLocale = null;
        return;
      }

      if (!this.surveyData.SurveySelectedLanguages)
        this.surveyData.SurveySelectedLanguages = [];

      let newLanguage = {};
      newLanguage.LanguageCode = this.newSurveyLanguage;
      if (this.newSurveyLanguageLocale)
        newLanguage.CountryCode = this.newSurveyLanguageLocale;
      newLanguage.IsDefault =
        this.surveyData.SurveySelectedLanguages.length > 0 ? false : true;

      this.surveyData.SurveySelectedLanguages.push(newLanguage);
      this.newSurveyLanguageLocale = null;
      this.$forceUpdate();
    },

    // Removes the language with the given key from the list of selected languages
    removeSelectedLanguage(languageCode, countryCode) {
      if (!this.surveyData.SurveySelectedLanguages) return;

      let idx = _.findIndex(this.surveyData.SurveySelectedLanguages, (l) => {
        return l.LanguageCode == languageCode && l.CountryCode == countryCode;
      });
      if (idx < 0) return;

      let isDefaultLanguage =
        this.surveyData.SurveySelectedLanguages[idx].IsDefault;

      this.surveyData.SurveySelectedLanguages.splice(idx, 1);
      if (this.surveyData.SurveySelectedLanguages.length === 0)
        delete this.surveyData.SurveySelectedLanguages;
      else if (isDefaultLanguage)
        this.surveyData.SurveySelectedLanguages[0].IsDefault = true;
      this.$forceUpdate();
    },

    setDefaultSurveyLanguage(index) {
      for (let i = 0; i < this.surveyData.SurveySelectedLanguages.length; i++) {
        this.surveyData.SurveySelectedLanguages[i].IsDefault = false;
      }
      this.surveyData.SurveySelectedLanguages[index].IsDefault = true;
    },

    // Writes the filename to the input of the survey attachment, after a file was selected
    onSurveyAttachmentFileChange(e) {
      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      let files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.attachmentFileObject = files[0];

      let uploadSuccess = (data) => {
        if (this.surveyData.SurveyAttachments) {
          this.surveyData.SurveyAttachments[0].DownloadId = data[0].DownloadId;
          this.surveyData.SurveyAttachments[0].DownloadFileName =
            this.attachmentFileObject.name;
        } else this.surveyData.SurveyAttachments = data;

        this.globals.showSuccessSnackbar(this.lang.U1077);
        this.$forceUpdate();
      };
      this.globals.uploadFile(this.attachmentFileObject, false, uploadSuccess);
      e.target.value = null;
    },

    // Removes the survey attachment file from the survey data and resets the input field
    removeSurveyAttachmentFile() {
      this.surveyData.SurveyAttachments = [{}];
      this.attachmentFileObject = {};
      this.$forceUpdate();
    },

    // Writes the filename to the input of the survey logo, after a file was selected
    onSurveyLogoFileChange(e) {
      if (!this.globals.isAccessAllowed("LoopOp_Upload_Create")) {
        this.globals.showErrorSnackbar(this.lang.U1076);
        return;
      }

      let files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) return;

      this.logoFileObject = files[0];

      let uploadSuccess = (data) => {
        this.surveyData.SurveyLogoId = data[0].DownloadId;
        this.surveyData.SurveyLogoFileName = this.logoFileObject.name;
        this.globals.showSuccessSnackbar(this.lang.U1078);
        this.$forceUpdate();
      };
      this.globals.uploadFile(this.logoFileObject, false, uploadSuccess);
      e.target.value = null;
    },

    // Removes the survey logo file from the survey data and resets the input field
    removeSurveyLogoFile() {
      delete this.surveyData.SurveyLogoId;
      delete this.surveyData.SurveyLogoFileName;
      this.logoFileObject = {};
      this.$forceUpdate();
    },

    // Stores the current visibility settings to the data object
    storeCurrentVisibilitySettings() {
      var currentData = this.currentVisibilitySettings;

      if (!this.visibilitySettings) this.visibilitySettings = {};

      this.visibilitySettings[currentData.selected] =
        currentData.selectedGroups;
    },

    // Reads the current visibility settings for the given element from the data object
    readCurrentVisibilitySettings(element) {
      let currentData = this.currentVisibilitySettings;
      let dataStorage = [];
      if (this.visibilitySettings && this.visibilitySettings[element])
        dataStorage = this.visibilitySettings[element];

      currentData.selected = element;
      currentData.selectedGroups = dataStorage;
    },

    // Resets the all visibility settings to the default values
    resetVisibilitySettings() {
      this.currentVisibilitySettings.selected = "survey";
      this.currentVisibilitySettings.selectedGroups = [];
      this.visibilitySettings = {};
    },

    // Takes all available groups into current visibility settings and removes all groups if they are already selected
    toggleAllVisibilityGroups() {
      let ids = Object.keys(this.surveyGroupList);

      if (ids.length <= this.currentVisibilitySettings.selectedGroups.length) {
        this.currentVisibilitySettings.selectedGroups = [];
        return;
      }

      let num;
      for (let i = 0; i < ids.length; i++) {
        num = ids[i];
        if (this.currentVisibilitySettings.selectedGroups.indexOf(num) < 0)
          this.currentVisibilitySettings.selectedGroups.push(num);
      }
    },

    // Refreshes displayed visibility settings after changing the submenu
    visibilitySubmenuChanged(element) {
      this.storeCurrentVisibilitySettings();
      this.readCurrentVisibilitySettings(element);
      var currentData = this.currentVisibilitySettings;

      // Update header text
      switch (element) {
        case "survey":
          currentData.headerText = this.lang.U1011;
          break;
        case "date":
          currentData.headerText = this.lang.U1012;
          break;
        case "time":
          currentData.headerText = this.lang.U1013;
          break;
        case "points":
          currentData.headerText = this.lang.U1014;
          break;
        case "remarks":
          currentData.headerText = this.lang.U1015;
          break;
        case "attachment":
          currentData.headerText = this.lang.U1016;
          break;
        default:
          currentData.headerText = "";
      }
    },

    // Fills the editSurvey dialog with data, depending on the dialog mode.
    async openEditSurveyDialog() {
      // document.getElementById("visibilitySurveyLink").click();
      this.clientList = await this.globals.getClientList();

      if (
        this.feature.isAudiTarget &&
        this.feature.isEnabled("audi_importers")
      ) {
        this.globals.getImporterList((data) => {
          this.importerList = data;
          if (this.$refs.editSurveyImporterSelect)
            this.$refs.editSurveyImporterSelect.updateValue();
        });
      }

      this.visibilitySubmenuChanged("survey");

      this.removeSurveyAttachmentFile();
      this.removeSurveyLogoFile();
      this.newSurveyLanguage = null;
      this.newSurveyLanguageLocale = null;

      if (this.dialogModeAdd) {
        this.dialogTitle = this.lang.U0032;
        this.surveyData = {};
        if (this.selectedClient)
          this.surveyData.ClientGuid = this.selectedClient.ClientGuid;
        this.surveyData.SurveyAttachments = [{}];
        this.surveyData.SurveyActive = true;
        this.surveyData.SurveyShowAttachmentsPage = true;
        this.surveyData.SurveySkillLevel = 3;
        // todo remove where the feature is not needed
        this.surveyData.SurveyShowHistoryCounter = 0;

        if (
          this.feature.isAudiTarget &&
          this.feature.isEnabled("audi_importers") &&
          this.clientList[0]
        )
          this.surveyData.ClientGuid = this.clientList[0].ClientGuid;

        if (this.surveyData.ClientGuid) this.getSurveyGroupList();

        this.resetVisibilitySettings();
        $("#editSurveyDialog").modal("show");
      } else {
        this.dialogTitle = this.copySurvey ? this.lang.U1061 : this.lang.U0033;
        this.surveyData = { SurveyAttachments: [{}] };

        $.ajax({
          method: "GET",
          url: `api/Surveys/${this.selectedSurvey.SurveyId}`,
          success: (data) => {
            if (!data.Error) {
              this.surveyData = data.SurveyData;
              this.visibilitySettings = data.VisibilitySettings;
              if (this.surveyData.Importers) {
                this.surveyData.ImporterGuid =
                  this.surveyData.Importers[0].ImporterGuid;
                delete this.surveyData.Importers;
              }
              this.readCurrentVisibilitySettings(
                this.currentVisibilitySettings.selected
              );
              this.logoFileObject.name = this.surveyData.SurveyLogoFileName;
              if (!this.surveyData.SurveyAttachments)
                this.surveyData.SurveyAttachments = [{}];
              else
                this.attachmentFileObject.name =
                  this.surveyData.SurveyAttachments[0].DownloadFileName;
              $("#editSurveyDialog").modal("show");

              this.getSurveyGroupList();
            } else {
              this.globals.showErrorSnackbar(data.Error);
              this.$emit("dialogClosed");
            }
          },
          error: () => {
            console.error(
              "Survey data access failed in openEditSurveyDialog()"
            );
            this.globals.showErrorSnackbar(this.lang.U1086);
            this.$emit("dialogClosed");
          },
        });
      }
      this.showAlert = false;
      this.resetValidationErrors("editSurveyDialog");
    },

    // Closes the editSurveyDialog
    closeEditSurveyDialog() {
      $("#editSurveyDialog").modal("hide");
    },

    // Sends the data from editSurvey dialog to the server to store it in the database
    saveEditSurveyDialogData(forceSave) {
      if (!this.surveyData.SurveySelectedLanguages) {
        this.globals.showErrorSnackbar(this.lang.U1079);
        return;
      }
      if (!this.surveyData.ClientGuid) {
        this.globals.showErrorSnackbar(this.lang.U1080);
        return;
      }

      this.storeCurrentVisibilitySettings();

      let sendData = {
        SurveyData: _.cloneDeep(this.surveyData),
        VisibilitySettings: _.cloneDeep(this.visibilitySettings),
      };

      if (!sendData.SurveyData.isMasterSurvey) {
        this.surveyData.MasterSurveyForWave = null;
        sendData.SurveyData.MasterSurveyForWave = null;
      }
      if (!this.surveyData.SurveyAttachments[0].DownloadId) {
        sendData.SurveyData.SurveyAttachments = [];
      }

      if (sendData.SurveyData.ImporterGuid) {
        sendData.SurveyData.Importers = [
          { ImporterGuid: sendData.SurveyData.ImporterGuid },
        ];
        delete sendData.SurveyData.ImporterGuid;
      }

      if (this.dialogModeAdd || this.copySurvey) {
        if (this.copySurvey) {
          sendData.IsCopyOf = this.surveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyGuid;
          delete sendData.SurveyData.SurveyId;
        }
        // Create new survey
        $.ajax({
          method: "POST",
          url: "api/Surveys",
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }
            // If POST was successful, refresh displayed data and hide dialog
            this.globals.showSuccessSnackbar(this.lang.U1081);
            this.closeEditSurveyDialog();
            this.$emit("dialogDataSaved", data[0]);
            this.$emit("surveyEditorRedirect", data[0].SurveyId);
          },
          error: (XMLHttpRequest, textStatus, errorThrown) => {
            console.error(
              `Error on POST in saveEditSurveyDialogData=> status:${textStatus} error:${errorThrown}`
            );
            this.globals.showErrorSnackbar(this.lang.U1082);
          },
        });
      } else {
        // Update existing survey
        if (forceSave) sendData.ForceSave = true;
        $.ajax({
          method: "PUT",
          url: "api/Surveys/" + this.surveyData.SurveyId,
          data: JSON.stringify(sendData),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            if (data.Error) {
              this.globals.showErrorSnackbar(data.Error);
              console.error(data.Error);
              return;
            }

            if (
              data &&
              data.Confirmation &&
              data.Confirmation === "EXISTING_CHECKS"
            ) {
              this.globals.$off("SaveSurveyDataYesConfirmation");
              this.globals.$on("SaveSurveyDataYesConfirmation", () => {
                this.saveEditSurveyDialogData(true);
              });

              this.globals.$emit("openGlobalConfirmationDialog", {
                initiator: "SaveSurveyData",
                confirmationTitle: this.lang.U1062,
                colorRed: true,
                yesButtonText: this.lang.U1063,
                noButtonText: this.lang.U1064,
                htmlText: `<b>
                  <p>${this.lang.U1065}</p>
                  <p class="text-uppercase">${this.lang.U1066}</p>
                </b>`,
              });
            } else {
              // If PUT was successful, refresh displayed data and hide dialog
              this.globals.showSuccessSnackbar(this.lang.U1083);
              this.closeEditSurveyDialog();
              this.$emit("dialogDataSaved", sendData.SurveyData);
            }
          },
          error: (XMLHttpRequest, textStatus, errorThrown) => {
            console.error("Error on PUT in saveEditSurveyDialogData()");
            console.error(XMLHttpRequest, ` ${textStatus} : ${errorThrown}`);
            this.globals.showErrorSnackbar(this.lang.U1084);
          },
        });
      }
    },
  },
  watch: {
    showDialog() {
      if (
        this.showDialog &&
        (this.dialogModeAdd ||
          this.globals.isAccessAllowed("LoopOp_Surveys_Read"))
      )
        this.openEditSurveyDialog();
      else {
        this.closeEditSurveyDialog();
        this.$emit("dialogClosed");
      }
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: [
    "selectedSurvey",
    "selectedClient",
    "showDialog",
    "dialogModeAdd",
    "copySurvey",
    "languageList",
    "localesList",
  ],
  data() {
    // Global data inside the component is stored here
    return {
      dialogTitle: "", // Title of the dialog
      newSurveyLanguage: null,
      newSurveyLanguageLocale: null,
      languageLocaleList: {},
      surveyData: {
        SurveyAttachments: [{}],
      }, // The survey data of the selected survey is stored here
      visibilitySettings: {},
      showAlert: false, // true --> Alert for validation errors is visible
      invalidInputIds: [], // IDs of inputs with validation error
      logoFileObject: {},
      attachmentFileObject: {},
      surveyGroupList: {},
      clientList: [],
      waveList: [],
      importerList: [],
      currentVisibilitySettings: {
        selected: "survey",
        headerText: "",
        selectedGroups: [],
      },
      initialVisibilitySettings: {
        survey: [],
        date: [],
        time: [],
        points: [],
        remarks: [],
        attachment: [],
      },
      lang: {
        U0015: "General",
        U0016: "Client",
        U0017: "Title",
        U0018: "Title 2 (subtitle)",
        U0019: "Title 3 (subtitle)",
        U0020: "This is a required entry!",
        U0021:
          "The inputs are incorrect. Please check the fields marked in red!",
        U0022: "Cancel",
        U0023: "Save",
        U0032: "Add survey",
        U0033: "Edit survey",
        U0040: "Difficulty",
        U0041: "simple",
        U0042: "difficult",
        U1000: "Please select...",
        U1001: "Security group for survey",
        U1002: "Survey",
        U1003: "Date",
        U1004: "Time",
        U1005: "Points",
        U1006: "Mystery Shopper information",
        U1007: "Annex",
        U1011: "The survey is visible for the following groups",
        U1012:
          "Date (Client view / Export) is visible for the following groups",
        U1013:
          "Time (Client view / Export) is visible for the following groups",
        U1014:
          "Points (Client view / Export)  are visible for the following groups",
        U1015:
          "Mystery Shopper information are visible for the following groups",
        U1016:
          "Annexes (Client view / Export) are visible for the following groups",
        U1017: "Language versions",
        U1018: "Language selection",
        U1019: "Add",
        U1020: "Language",
        U1021: "Actions",
        U1022: "Annex",
        U1023: "Name of the annex",
        U1024: "File",
        U1025: "Please select a file...",
        U1026: "Other",
        U1027: "Logo",
        U1028: "Please select a logo...",
        U1029: "Minimal annexes",
        U1031: "Activated",
        U1032: "Select all",
        U1033: "Clean selection",
        U1034: "Select file",
        U1035: "Download file",
        U1036: "Delete file",
        U1037: "Survey active",
        U1038: "Is a CX Survey",
        U1040: "This language was already selected",
        U1059: "Country",
        U1060:
          "The following content will NOT be copied and has to be set manually",
        U1061: "Copy survey",
        U1062: "Save survey",
        U1063: "Yes",
        U1064: "No",
        U1065:
          "ATTENTION: There are already existing checks based on this survey. Do you really want to save?",
        U1066: "All affected checks will be changed by this action",
        U1067: "Please select a language...",
        U1068: "Please select a country...",
        U1069: "Reporting default",
        U1074: "Attachments allowed",
        U1075: "Importer",
        U1076: "Permission denied",
        U1077: "Attachment upload successful",
        U1078: "Logo upload successful",
        U1079: "No survey language selected",
        U1080: "No client selected",
        U1081: "Survey creation successful",
        U1082: "Survey creation failed",
        U1083: "Survey update successful",
        U1084: "Survey update failed",
        U1085: "Survey group data access failed",
        U1086: "Survey data access failed",
        U1087: "Show survey history",
        U1088: "CX Exploration Sichtbar",
        U1089: "Is Master survey",
        U1090: "Master survey for wave",
        U1091: "valid for wave",
        U1092: "Number of Histories to be shown",
      },
    };
  },
};
</script>

<style scoped>
input[type="number"] {
  width: 100%;
  font-size: 1.1em;
}

/* Tabs for visibility settings */
.nav-visibility {
  background-color: var(--color-primary);
  padding: 0px;
}
.nav-visibility > li {
  text-align: center;
  /* float: none; */
  /* display: inline-block; */
}
.nav-visibility > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-visibility > li.active > a {
  font-weight: bold;
}

/* Visibility content styling */
.tab-content-visibility {
  text-align: center;
  float: none;
  display: inline-block;
}
.table-content-visibility {
  border: 1px solid lightgray;
  max-height: 200px;
  min-height: 200px;
  margin-right: 0px;
  overflow: auto;
}

.form-group {
  overflow: hidden;
}
.form-group-files {
  padding: 2px 0;
}

.copy-survey-message {
  text-align: left;
}
#showSurveyHistoryInfoIcon {
  position: relative;
  left: 10px;
  margin: -5px;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// SurveyManagementEditModal.vue?b57fc72a